<!-- 登录 -->
<template>
  <div style="height: 100%; background: #253746;">
    <Header></Header>
    <div class="login tc">
      <p class="fb tc f20 pt30 mb10">RedWealth</p>
      <el-input v-model="account" placeholder="请输入账号" prefix-icon="el-icon-user" type="text"></el-input>
      <el-input v-model="password" placeholder="请输入密码" prefix-icon="el-icon-unlock" type="password" show-password></el-input>
<!--      <div style='text-align: right'><span style='margin-right: 40px' @click='toSignup'>没有账号，开始注册</span></div>-->
      <el-button class="co-f mt20" @click="login">登录</el-button>
    </div>
  </div>
</template>

<script>
import Header from './Header.vue'
export default {
  name: 'Home',
  data () {
    return {
      account: '',
      password: ''
    }
  },
  components: { Header },
  mounted () { },
  methods: {
    toSignup () {
      this.$router.push({name:'SignUp'})
    },
    login () {
      // this.$router.push({name: 'KnowYou'})
      const url = this.$api.Login
      // // {gq1 123456}
      if (this.account === '') {
        this.$message({type: 'error', message: '请输入账号！'})
        return
      }
      if (this.password === '') {
        this.$message({type: 'error', message: '请输入密码！'})
        return
      }
      const params = {
        "username": this.account,
        "password": this.password
      }
      let data = new FormData()
      data.append('username', this.account)
      data.append('password', this.password)
      this.$http.post(url, data, {}, window._env_.api_url, res => {
        if (res.status >= 200 && res.status < 300) {
          localStorage.setItem('token', res.data.access_token)
          this.$store.dispatch('setToken', res.data.access_token)
          this.$router.push({name: 'KnowYou'})
         }
      })
    }
   }
}
</script>

<style scoped>
.login{
   width: 80%;
   height: 335px;
   border-radius: 20px;
   background: #fff;
   margin: 120px auto;
}
.el-input{
  width: 90%;
  height: 38px;
  line-height: 38px;
  margin: 20px auto;
}
.el-button{
  width: 90%;
  background: #e90a5b;
  border-color: #e90a5b;
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue